<template>
  <div id="app" class="text-n-800">
    <router-view></router-view>
    <l-dialog-wrapper />
    <l-notification-wrapper />
    <div id="appRoot"></div>
  </div>
</template>

<script setup lang="ts">
import { LDialogWrapper, LNotificationWrapper } from '@last/core-ui/paprika'
</script>
